// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"f0b71e63","46":"e7369b46","193":"c2bd7fcb","216":"5d46bf8c","264":"5147e9d9","475":"dcf7bb1a","669":"670e7a22","773":"6a3c68c3","925":"4f2fe926","986":"1bb62644"}[chunkId] + ".chunk.js";
};